<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"
  *ngIf="isErrorMessageDisplay"></app-sg-aria-message>
<h1 *ngIf="workClscode">{{ workClscode == '2' ? '供給再開結果登録（一般供給再開）':'供給再開結果登録（簡易供給再開）'}}</h1>

<form [formGroup]="requestFormGroup" *ngIf="initResponse && codeMap" (ngSubmit)="onClickButton('submit')">
  <!-- 供給停止結果登録画面_顧客情報 -->
  <app-sgke360d-customer-info [basicInfoArea]="initResponse.initialhyojiInfo.basicInfoArea">
  </app-sgke360d-customer-info>

  <!-- 供給停止結果登録画面_結果登録エリア -->
  <app-sgke360d-regist-area [initResponse]="initResponse" [codeMap]="codeMap"
    (onClickButtonEvent)="onClickButton($event)" (onModalIsDisplayEvent)="onModalIsDisplay($event)"
    (drawFlgEvent)="drawFlg = $event">
  </app-sgke360d-regist-area>
</form>